'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dEvent$002dStream from "./com.raquo.airstream.core.-Event-Stream.js";
import * as $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal from "./com.raquo.airstream.misc.-Map-Signal.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits from "./com.raquo.laminar.api.-Implicits.js";
import * as $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dSeq$0024collection$002dSeq$002dRenderable$0024 from "./com.raquo.laminar.modifiers.-Renderable-Seq$collection-Seq-Renderable$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024$0024anon$002415 from "./dev.cheleb.scalamigen.-Form$package$$anon$15.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dHidden$002dEvent$0024 from "./dev.cheleb.scalamigen.-Hidden-Event$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dInvalide$002dEvent from "./dev.cheleb.scalamigen.-Invalide-Event.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dShown$002dEvent$0024 from "./dev.cheleb.scalamigen.-Shown-Event$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dValid$002dEvent$0024 from "./dev.cheleb.scalamigen.-Valid-Event$.js";
import * as $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid from "./dev.cheleb.scalamigen.-Validation-Status$-Invalid.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Form$package$() {
}
export { $c_Ldev_cheleb_scalamigen_Form$package$ as $c_Ldev_cheleb_scalamigen_Form$package$ };
$p = $c_Ldev_cheleb_scalamigen_Form$package$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Form$package$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Form$package$() {
}
export { $h_Ldev_cheleb_scalamigen_Form$package$ as $h_Ldev_cheleb_scalamigen_Form$package$ };
$h_Ldev_cheleb_scalamigen_Form$package$.prototype = $p;
$p.bF = (function(path) {
  var f = ((_$1$2) => _$1$2.wt);
  if ((path === $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
    var $x_1 = $j_java$002elang$002e$002dObject.$m_sci_Nil$();
  } else {
    var x0 = path.E();
    var h = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
    var t = h;
    var rest = path.H();
    while ((rest !== $j_java$002elang$002e$002dObject.$m_sci_Nil$())) {
      var x0$1 = rest.E();
      var nx = new $j_java$002elang$002e$002dObject.$c_sci_$colon$colon(f(x0$1), $j_java$002elang$002e$002dObject.$m_sci_Nil$());
      t.ao = nx;
      t = nx;
      rest = rest.H();
    }
    var $x_1 = h;
  }
  return $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T($x_1, "", ".", "");
});
$p.QU = (function(errorBus) {
  return $j_com$002eraquo$002eairstream$002ecore$002e$002dEvent$002dStream.$f_Lcom_raquo_airstream_core_EventStream__scanLeft__O__F2__Lcom_raquo_airstream_core_Signal(errorBus.rB, $j_java$002elang$002e$002dObject.$m_sci_Map$EmptyMap$(), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction2_$$Lambda$b4228bd32034ae3b2f0c5fc896319aa4b79b55f8(((x$1$2, x$2$2) => {
    var x113 = new $j_java$002elang$002e$002dObject.$c_T2(x$1$2, x$2$2);
    var x115 = x113.ad;
    var acc = x113.ac;
    if ((x115 !== null)) {
      var field = x115.ac;
      var event = x115.ad;
      if (($j_dev$002echeleb$002escalamigen$002e$002dValid$002dEvent$0024.$m_Ldev_cheleb_scalamigen_ValidEvent$() === event)) {
        return acc.rh(field);
      }
      if ((event instanceof $j_dev$002echeleb$002escalamigen$002e$002dInvalide$002dEvent.$c_Ldev_cheleb_scalamigen_InvalideEvent)) {
        return acc.hu(field, new $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid.$c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid(event.rM, true));
      }
      if (($j_dev$002echeleb$002escalamigen$002e$002dHidden$002dEvent$0024.$m_Ldev_cheleb_scalamigen_HiddenEvent$() === event)) {
        return acc.C2(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$1) => {
          if ((x$1$2$1 !== null)) {
            var x94 = x$1$2$1.ac;
            var x95 = x$1$2$1.ad;
            if ((x95 instanceof $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid.$c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid)) {
              var x98 = x95.hB;
              if ((x95.g5 && (!(!x94.startsWith(field))))) {
                return new $j_java$002elang$002e$002dObject.$c_T2(x94, new $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid.$c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid(x98, false));
              }
            }
            return new $j_java$002elang$002e$002dObject.$c_T2(x94, x95);
          }
          throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x$1$2$1);
        })));
      }
      if (($j_dev$002echeleb$002escalamigen$002e$002dShown$002dEvent$0024.$m_Ldev_cheleb_scalamigen_ShownEvent$() === event)) {
        return acc.C2(new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((x$1$2$2) => {
          if ((x$1$2$2 !== null)) {
            var x103 = x$1$2$2.ac;
            var x104 = x$1$2$2.ad;
            if ((x104 instanceof $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid.$c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid)) {
              var x107 = x104.hB;
              if (((!x104.g5) && (!(!x103.startsWith(field))))) {
                return new $j_java$002elang$002e$002dObject.$c_T2(x103, new $j_dev$002echeleb$002escalamigen$002e$002dValidation$002dStatus$0024$002dInvalid.$c_Ldev_cheleb_scalamigen_ValidationStatus$Invalid(x107, true));
              }
            }
            return new $j_java$002elang$002e$002dObject.$c_T2(x103, x104);
          }
          throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x$1$2$2);
        })));
      }
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(event);
    }
    throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(x113);
  })));
});
$p.TS = (function(errorBus, f) {
  return $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_com$002eraquo$002eairstream$002emisc$002e$002dMap$002dSignal.$c_Lcom_raquo_airstream_misc_MapSignal(), $m_Ldev_cheleb_scalamigen_Form$package$().QU(errorBus), new $j_java$002elang$002e$002dObject.$c_sr_AbstractFunction1_$$Lambda$7afc3dd0acc1681fb022ef921c83979087aaa919(((errors$2) => $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d.U().u($j_java$002elang$002e$002dObject.$ct_sjsr_WrappedVarArgs__sjs_js_Array__(new $j_java$002elang$002e$002dObject.$c_sjsr_WrappedVarArgs(), [$j_com$002eraquo$002elaminar$002eapi$002e$002dImplicits.$f_Lcom_raquo_laminar_api_Implicits__nodeSeqToModifier__O__Lcom_raquo_laminar_modifiers_RenderableSeq__Lcom_raquo_laminar_modifiers_Modifier($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$().d, errors$2.ib(new $j_dev$002echeleb$002escalamigen$002e$002dForm$0024package$0024$0024anon$002415.$c_Ldev_cheleb_scalamigen_Form$package$$anon$15(f)).li(), $j_com$002eraquo$002elaminar$002emodifiers$002e$002dRenderable$002dSeq$0024collection$002dSeq$002dRenderable$0024.$m_Lcom_raquo_laminar_modifiers_RenderableSeq$collectionSeqRenderable$())])))), $j_java$002elang$002e$002dObject.$m_s_None$());
});
var $d_Ldev_cheleb_scalamigen_Form$package$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Form$package$, "dev.cheleb.scalamigen.Form$package$", ({
  j9: 1
}));
export { $d_Ldev_cheleb_scalamigen_Form$package$ as $d_Ldev_cheleb_scalamigen_Form$package$ };
var $n_Ldev_cheleb_scalamigen_Form$package$;
function $m_Ldev_cheleb_scalamigen_Form$package$() {
  if ((!$n_Ldev_cheleb_scalamigen_Form$package$)) {
    $n_Ldev_cheleb_scalamigen_Form$package$ = new $c_Ldev_cheleb_scalamigen_Form$package$();
  }
  return $n_Ldev_cheleb_scalamigen_Form$package$;
}
export { $m_Ldev_cheleb_scalamigen_Form$package$ as $m_Ldev_cheleb_scalamigen_Form$package$ };
